"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'WarrantyTypeField',
    props: {
        value: null
    },
    emits: ["input"],
    setup(__props, { emit }) {
        const props = __props;
        const input = (0, vue_2.ref)("");
        (0, vue_2.watch)(input, () => {
            emit("input", input.value);
        });
        return { __sfc: true, props, emit, input };
    }
});
